// extracted by css-extract-rspack-plugin
export default {"card":"card-aWYa4a","selected":"selected-e7Aa63","disabled":"disabled-Nz3wo1","dimmed":"dimmed-Fvxg6W"};